export default {
  "config": {
    "trial": "tones-3",
    "id": "24h-dbp",
    "type": "line",
    "title": "Effects of Solriamfetol on DBP as Measured by 24 h ABPM<sup>26</sup>",
    "xAxis": {
      "groups": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ],
      "padding": 0.1,
      "label": {
        "text": "Time of day"
      },
      "overrides": {
        "1": "6 AM -<br>8 AM",
        "2": "8 AM -<br>10 AM",
        "3": "10 AM -<br>12 PM",
        "4": "12 PM -<br>2 PM",
        "5": "2 PM -<br>4 PM",
        "6": "4 PM -<br>6 PM",
        "7": "6 PM -<br>8 PM",
        "8": "8 PM -<br>10 PM",
        "9": "10 PM -<br>12 AM",
        "10": "12 AM -<br>2 AM",
        "11": "2 AM -<br>4 AM",
        "12": "4 AM -<br>6 AM"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": 50,
      "high": 100,
      "inc": 10,
      "label": {
        "text": [
          "Mean (SD) DBP (mmHg)"
        ]
      }
    },
    "legend": [
      {
        "entry": "pbo-screening",
        "label": "Placebo at screening",
        "color": "#868686",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Placebo at screening"
      },
      {
        "entry": "pbo-w8",
        "label": "Placebo at week 8",
        "color": "#868686",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Placebo at week 8"
      },
      {
        "entry": "sol-375-screening",
        "label": "Solriamfetol <no-break>37.5 mg</no-break> at screening",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 37.5 mg at screening"
      },
      {
        "entry": "sol-375-w8",
        "label": "Solriamfetol <no-break>37.5 mg</no-break> at week 8",
        "color": "#006e8a",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Solriamfetol 37.5 mg at week 8"
      },
      {
        "entry": "sol-75-screening",
        "label": "Solriamfetol <no-break>75 mg</no-break> at screening",
        "color": "#ffce00",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 75 mg at screening"
      },
      {
        "entry": "sol-75-w8",
        "label": "Solriamfetol <no-break>75 mg</no-break> at week 8",
        "color": "#ffce00",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Solriamfetol 75 mg at week 8"
      },
      {
        "entry": "sol-150-screening",
        "label": "Solriamfetol <no-break>150 mg</no-break> at screening",
        "color": "#73cac3",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 150 mg at screening"
      },
      {
        "entry": "sol-150-w8",
        "label": "Solriamfetol <no-break>150 mg</no-break> at week 8",
        "color": "#73cac3",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Solriamfetol 150 mg at week 8"
      },
      {
        "entry": "sol-300-screening",
        "label": "Solriamfetol <no-break>300 mg</no-break> at screening",
        "color": "#be5b92",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 300 mg at screening"
      },
      {
        "entry": "sol-300-w8",
        "label": "Solriamfetol <no-break>300 mg</no-break> at week 8",
        "color": "#be5b92",
        "line": "dashed",
        "shape": "hollow",
        "tooltip": "Solriamfetol 300 mg at week 8"
      }
    ],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "At week 8, increases in DBP were transient throughout the day."
    ],
    "useFootnoteTooltip": true,
    "trendLines": [],
    "tooltipHeaders": [
      "Treatment group",
      "mmHg"
    ],
    "nValueTable": {
      "type": "regular",
      "rows": 2,
      "sourceField": "y"
    },
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "pbo-screening",
            "label": "Placebo at screening",
            "color": "#868686",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Placebo at screening"
          },
          {
            "entry": "pbo-w8",
            "label": "Placebo at week 8",
            "color": "#868686",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Placebo at week 8"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-375-screening",
            "label": "Solriamfetol <no-break>37.5 mg</no-break> at screening",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 37.5 mg at screening"
          },
          {
            "entry": "sol-375-w8",
            "label": "Solriamfetol <no-break>37.5 mg</no-break> at week 8",
            "color": "#006e8a",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Solriamfetol 37.5 mg at week 8"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-75-screening",
            "label": "Solriamfetol <no-break>75 mg</no-break> at screening",
            "color": "#ffce00",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 75 mg at screening"
          },
          {
            "entry": "sol-75-w8",
            "label": "Solriamfetol <no-break>75 mg</no-break> at week 8",
            "color": "#ffce00",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Solriamfetol 75 mg at week 8"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-150-screening",
            "label": "Solriamfetol <no-break>150 mg</no-break> at screening",
            "color": "#73cac3",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 150 mg at screening"
          },
          {
            "entry": "sol-150-w8",
            "label": "Solriamfetol <no-break>150 mg</no-break> at week 8",
            "color": "#73cac3",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Solriamfetol 150 mg at week 8"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-300-screening",
            "label": "Solriamfetol <no-break>300 mg</no-break> at screening",
            "color": "#be5b92",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 300 mg at screening"
          },
          {
            "entry": "sol-300-w8",
            "label": "Solriamfetol <no-break>300 mg</no-break> at week 8",
            "color": "#be5b92",
            "line": "dashed",
            "shape": "hollow",
            "tooltip": "Solriamfetol 300 mg at week 8"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "name": "pbo-screening",
      "color": "#868686",
      "sets": [
        {
          "name": "pbo-screening",
          "color": "#868686",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Placebo at screening, mean",
          "tooltipLabel": "Placebo at screening",
          "points": [
            {
              "x": "1",
              "y": 72.94,
              "extreme": {
                "upper": 9.731,
                "lower": 9.731
              },
              "label": {
                "text": 72.94,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "2",
              "y": 76.39,
              "extreme": {
                "upper": 10.009,
                "lower": 10.009
              },
              "label": {
                "text": 76.39,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "3",
              "y": 78.08,
              "extreme": {
                "upper": 8.879,
                "lower": 8.879
              },
              "label": {
                "text": 78.08,
                "sup": null,
                "override": ""
              },
              "nvalue": 115
            },
            {
              "x": "4",
              "y": 78.84,
              "extreme": {
                "upper": 9.192,
                "lower": 9.192
              },
              "label": {
                "text": 78.84,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "5",
              "y": 77.78,
              "extreme": {
                "upper": 9.422,
                "lower": 9.422
              },
              "label": {
                "text": 77.78,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "6",
              "y": 76.79,
              "extreme": {
                "upper": 10.26,
                "lower": 10.26
              },
              "label": {
                "text": 76.79,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "7",
              "y": 78.06,
              "extreme": {
                "upper": 10.139,
                "lower": 10.139
              },
              "label": {
                "text": 78.06,
                "sup": null,
                "override": ""
              },
              "nvalue": 115
            },
            {
              "x": "8",
              "y": 76.18,
              "extreme": {
                "upper": 8.555,
                "lower": 8.555
              },
              "label": {
                "text": 76.18,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "9",
              "y": 72.59,
              "extreme": {
                "upper": 11.509,
                "lower": 11.509
              },
              "label": {
                "text": 72.59,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "10",
              "y": 67.7,
              "extreme": {
                "upper": 9.497,
                "lower": 9.497
              },
              "label": {
                "text": 67.7,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "11",
              "y": 66.46,
              "extreme": {
                "upper": 8.808,
                "lower": 8.808
              },
              "label": {
                "text": 66.46,
                "sup": null,
                "override": ""
              },
              "nvalue": 116
            },
            {
              "x": "12",
              "y": 68.06,
              "extreme": {
                "upper": 9.671,
                "lower": 9.671
              },
              "label": {
                "text": 68.06,
                "sup": null,
                "override": ""
              },
              "nvalue": 114
            }
          ]
        }
      ]
    },
    {
      "name": "pbo-w8",
      "color": "#868686",
      "sets": [
        {
          "name": "pbo-w8",
          "color": "#868686",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Placebo at week 8, mean",
          "tooltipLabel": "Placebo at week 8",
          "points": [
            {
              "x": "1",
              "y": 71.57,
              "extreme": {
                "upper": 9.438,
                "lower": 9.438
              },
              "label": {
                "text": 71.57,
                "sup": null,
                "override": ""
              },
              "nvalue": 92
            },
            {
              "x": "2",
              "y": 76.08,
              "extreme": {
                "upper": 8.494,
                "lower": 8.494
              },
              "label": {
                "text": 76.08,
                "sup": null,
                "override": ""
              },
              "nvalue": 92
            },
            {
              "x": "3",
              "y": 78.51,
              "extreme": {
                "upper": 8.484,
                "lower": 8.484
              },
              "label": {
                "text": 78.51,
                "sup": null,
                "override": ""
              },
              "nvalue": 94
            },
            {
              "x": "4",
              "y": 77.17,
              "extreme": {
                "upper": 9.936,
                "lower": 9.936
              },
              "label": {
                "text": 77.17,
                "sup": null,
                "override": ""
              },
              "nvalue": 94
            },
            {
              "x": "5",
              "y": 77.17,
              "extreme": {
                "upper": 8.986,
                "lower": 8.986
              },
              "label": {
                "text": 77.17,
                "sup": null,
                "override": ""
              },
              "nvalue": 93
            },
            {
              "x": "6",
              "y": 77.48,
              "extreme": {
                "upper": 8.765,
                "lower": 8.765
              },
              "label": {
                "text": 77.48,
                "sup": null,
                "override": ""
              },
              "nvalue": 91
            },
            {
              "x": "7",
              "y": 77.24,
              "extreme": {
                "upper": 10.039,
                "lower": 10.039
              },
              "label": {
                "text": 77.24,
                "sup": null,
                "override": ""
              },
              "nvalue": 93
            },
            {
              "x": "8",
              "y": 77.3,
              "extreme": {
                "upper": 8.613,
                "lower": 8.613
              },
              "label": {
                "text": 77.3,
                "sup": null,
                "override": ""
              },
              "nvalue": 91
            },
            {
              "x": "9",
              "y": 72.08,
              "extreme": {
                "upper": 9.596,
                "lower": 9.596
              },
              "label": {
                "text": 72.08,
                "sup": null,
                "override": ""
              },
              "nvalue": 93
            },
            {
              "x": "10",
              "y": 68.02,
              "extreme": {
                "upper": 10.245,
                "lower": 10.245
              },
              "label": {
                "text": 68.02,
                "sup": null,
                "override": ""
              },
              "nvalue": 94
            },
            {
              "x": "11",
              "y": 66.02,
              "extreme": {
                "upper": 8.967,
                "lower": 8.967
              },
              "label": {
                "text": 66.02,
                "sup": null,
                "override": ""
              },
              "nvalue": 93
            },
            {
              "x": "12",
              "y": 68.14,
              "extreme": {
                "upper": 9.458,
                "lower": 9.458
              },
              "label": {
                "text": 68.14,
                "sup": null,
                "override": ""
              },
              "nvalue": 92
            }
          ]
        }
      ]
    },
    {
      "name": "sol-375-screening",
      "color": "#006e8a",
      "sets": [
        {
          "name": "sol-375-screening",
          "color": "#006e8a",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 37.5 mg at screening, mean",
          "tooltipLabel": "Solriamfetol 37.5 mg at screening",
          "points": [
            {
              "x": "1",
              "y": 70.8,
              "extreme": {
                "upper": 11.036,
                "lower": 11.036
              },
              "label": {
                "text": 70.8,
                "sup": null,
                "override": ""
              },
              "nvalue": 56
            },
            {
              "x": "2",
              "y": 75.77,
              "extreme": {
                "upper": 10.904,
                "lower": 10.904
              },
              "label": {
                "text": 75.77,
                "sup": null,
                "override": ""
              },
              "nvalue": 55
            },
            {
              "x": "3",
              "y": 77.1,
              "extreme": {
                "upper": 9.495,
                "lower": 9.495
              },
              "label": {
                "text": 77.1,
                "sup": null,
                "override": ""
              },
              "nvalue": 53
            },
            {
              "x": "4",
              "y": 77.46,
              "extreme": {
                "upper": 10.114,
                "lower": 10.114
              },
              "label": {
                "text": 77.46,
                "sup": null,
                "override": ""
              },
              "nvalue": 54
            },
            {
              "x": "5",
              "y": 76.91,
              "extreme": {
                "upper": 9.729,
                "lower": 9.729
              },
              "label": {
                "text": 76.91,
                "sup": null,
                "override": ""
              },
              "nvalue": 55
            },
            {
              "x": "6",
              "y": 76.25,
              "extreme": {
                "upper": 8.858,
                "lower": 8.858
              },
              "label": {
                "text": 76.25,
                "sup": null,
                "override": ""
              },
              "nvalue": 55
            },
            {
              "x": "7",
              "y": 75.07,
              "extreme": {
                "upper": 9.777,
                "lower": 9.777
              },
              "label": {
                "text": 75.07,
                "sup": null,
                "override": ""
              },
              "nvalue": 53
            },
            {
              "x": "8",
              "y": 74.31,
              "extreme": {
                "upper": 9.456,
                "lower": 9.456
              },
              "label": {
                "text": 74.31,
                "sup": null,
                "override": ""
              },
              "nvalue": 55
            },
            {
              "x": "9",
              "y": 72.3,
              "extreme": {
                "upper": 8.98,
                "lower": 8.98
              },
              "label": {
                "text": 72.3,
                "sup": null,
                "override": ""
              },
              "nvalue": 57
            },
            {
              "x": "10",
              "y": 68.73,
              "extreme": {
                "upper": 9.977,
                "lower": 9.977
              },
              "label": {
                "text": 68.73,
                "sup": null,
                "override": ""
              },
              "nvalue": 57
            },
            {
              "x": "11",
              "y": 67.36,
              "extreme": {
                "upper": 9.028,
                "lower": 9.028
              },
              "label": {
                "text": 67.36,
                "sup": null,
                "override": ""
              },
              "nvalue": 57
            },
            {
              "x": "12",
              "y": 67.55,
              "extreme": {
                "upper": 10.823,
                "lower": 10.823
              },
              "label": {
                "text": 67.55,
                "sup": null,
                "override": ""
              },
              "nvalue": 57
            }
          ]
        }
      ]
    },
    {
      "name": "sol-375-w8",
      "color": "#006e8a",
      "sets": [
        {
          "name": "sol-375-w8",
          "color": "#006e8a",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Solriamfetol 37.5 mg at week 8, mean",
          "tooltipLabel": "Solriamfetol 37.5 mg at week 8",
          "points": [
            {
              "x": "1",
              "y": 71.91,
              "extreme": {
                "upper": 11.867,
                "lower": 11.867
              },
              "label": {
                "text": 71.91,
                "sup": null,
                "override": ""
              },
              "nvalue": 39
            },
            {
              "x": "2",
              "y": 77.9,
              "extreme": {
                "upper": 10.228,
                "lower": 10.228
              },
              "label": {
                "text": 77.9,
                "sup": null,
                "override": ""
              },
              "nvalue": 40
            },
            {
              "x": "3",
              "y": 78.15,
              "extreme": {
                "upper": 8.562,
                "lower": 8.562
              },
              "label": {
                "text": 78.15,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            },
            {
              "x": "4",
              "y": 77.44,
              "extreme": {
                "upper": 11.392,
                "lower": 11.392
              },
              "label": {
                "text": 77.44,
                "sup": null,
                "override": ""
              },
              "nvalue": 43
            },
            {
              "x": "5",
              "y": 77.26,
              "extreme": {
                "upper": 9.726,
                "lower": 9.726
              },
              "label": {
                "text": 77.26,
                "sup": null,
                "override": ""
              },
              "nvalue": 43
            },
            {
              "x": "6",
              "y": 77.44,
              "extreme": {
                "upper": 9.762,
                "lower": 9.762
              },
              "label": {
                "text": 77.44,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            },
            {
              "x": "7",
              "y": 76.3,
              "extreme": {
                "upper": 10.157,
                "lower": 10.157
              },
              "label": {
                "text": 76.3,
                "sup": null,
                "override": ""
              },
              "nvalue": 43
            },
            {
              "x": "8",
              "y": 75.01,
              "extreme": {
                "upper": 10.042,
                "lower": 10.042
              },
              "label": {
                "text": 75.01,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            },
            {
              "x": "9",
              "y": 70.09,
              "extreme": {
                "upper": 9.001,
                "lower": 9.001
              },
              "label": {
                "text": 70.09,
                "sup": null,
                "override": ""
              },
              "nvalue": 43
            },
            {
              "x": "10",
              "y": 67.26,
              "extreme": {
                "upper": 9.014,
                "lower": 9.014
              },
              "label": {
                "text": 67.26,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            },
            {
              "x": "11",
              "y": 67.33,
              "extreme": {
                "upper": 10.613,
                "lower": 10.613
              },
              "label": {
                "text": 67.33,
                "sup": null,
                "override": ""
              },
              "nvalue": 41
            },
            {
              "x": "12",
              "y": 67.44,
              "extreme": {
                "upper": 11.349,
                "lower": 11.349
              },
              "label": {
                "text": 67.44,
                "sup": null,
                "override": ""
              },
              "nvalue": 42
            }
          ]
        }
      ]
    },
    {
      "name": "sol-75-screening",
      "color": "#ffce00",
      "sets": [
        {
          "name": "sol-75-screening",
          "color": "#ffce00",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 75 mg at screening, mean",
          "tooltipLabel": "Solriamfetol 75 mg at screening",
          "points": [
            {
              "x": "1",
              "y": 71,
              "extreme": {
                "upper": 10.752,
                "lower": 10.752
              },
              "label": {
                "text": 71,
                "sup": null,
                "override": ""
              },
              "nvalue": 58
            },
            {
              "x": "2",
              "y": 74.46,
              "extreme": {
                "upper": 9.456,
                "lower": 9.456
              },
              "label": {
                "text": 74.46,
                "sup": null,
                "override": ""
              },
              "nvalue": 59
            },
            {
              "x": "3",
              "y": 77.45,
              "extreme": {
                "upper": 11.069,
                "lower": 11.069
              },
              "label": {
                "text": 77.45,
                "sup": null,
                "override": ""
              },
              "nvalue": 59
            },
            {
              "x": "4",
              "y": 76.46,
              "extreme": {
                "upper": 11.359,
                "lower": 11.359
              },
              "label": {
                "text": 76.46,
                "sup": null,
                "override": ""
              },
              "nvalue": 59
            },
            {
              "x": "5",
              "y": 76.49,
              "extreme": {
                "upper": 10.574,
                "lower": 10.574
              },
              "label": {
                "text": 76.49,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "6",
              "y": 75.57,
              "extreme": {
                "upper": 8.642,
                "lower": 8.642
              },
              "label": {
                "text": 75.57,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "7",
              "y": 76.85,
              "extreme": {
                "upper": 10.32,
                "lower": 10.32
              },
              "label": {
                "text": 76.85,
                "sup": null,
                "override": ""
              },
              "nvalue": 61
            },
            {
              "x": "8",
              "y": 74.26,
              "extreme": {
                "upper": 9.674,
                "lower": 9.674
              },
              "label": {
                "text": 74.26,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "9",
              "y": 70.86,
              "extreme": {
                "upper": 10.159,
                "lower": 10.159
              },
              "label": {
                "text": 70.86,
                "sup": null,
                "override": ""
              },
              "nvalue": 61
            },
            {
              "x": "10",
              "y": 66.19,
              "extreme": {
                "upper": 8.77,
                "lower": 8.77
              },
              "label": {
                "text": 66.19,
                "sup": null,
                "override": ""
              },
              "nvalue": 59
            },
            {
              "x": "11",
              "y": 65.95,
              "extreme": {
                "upper": 9.387,
                "lower": 9.387
              },
              "label": {
                "text": 65.95,
                "sup": null,
                "override": ""
              },
              "nvalue": 60
            },
            {
              "x": "12",
              "y": 66.04,
              "extreme": {
                "upper": 9.873,
                "lower": 9.873
              },
              "label": {
                "text": 66.04,
                "sup": null,
                "override": ""
              },
              "nvalue": 58
            }
          ]
        }
      ]
    },
    {
      "name": "sol-75-w8",
      "color": "#ffce00",
      "sets": [
        {
          "name": "sol-75-w8",
          "color": "#ffce00",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Solriamfetol 75 mg at week 8, mean",
          "tooltipLabel": "Solriamfetol 75 mg at week 8",
          "points": [
            {
              "x": "1",
              "y": 72.47,
              "extreme": {
                "upper": 12.372,
                "lower": 12.372
              },
              "label": {
                "text": 72.47,
                "sup": null,
                "override": ""
              },
              "nvalue": 51
            },
            {
              "x": "2",
              "y": 78.43,
              "extreme": {
                "upper": 11.596,
                "lower": 11.596
              },
              "label": {
                "text": 78.43,
                "sup": null,
                "override": ""
              },
              "nvalue": 50
            },
            {
              "x": "3",
              "y": 79.38,
              "extreme": {
                "upper": 11.364,
                "lower": 11.364
              },
              "label": {
                "text": 79.38,
                "sup": null,
                "override": ""
              },
              "nvalue": 51
            },
            {
              "x": "4",
              "y": 80.78,
              "extreme": {
                "upper": 10.388,
                "lower": 10.388
              },
              "label": {
                "text": 80.78,
                "sup": null,
                "override": ""
              },
              "nvalue": 47
            },
            {
              "x": "5",
              "y": 75.9,
              "extreme": {
                "upper": 11.48,
                "lower": 11.48
              },
              "label": {
                "text": 75.9,
                "sup": null,
                "override": ""
              },
              "nvalue": 49
            },
            {
              "x": "6",
              "y": 77.37,
              "extreme": {
                "upper": 12.494,
                "lower": 12.494
              },
              "label": {
                "text": 77.37,
                "sup": null,
                "override": ""
              },
              "nvalue": 48
            },
            {
              "x": "7",
              "y": 79.1,
              "extreme": {
                "upper": 8.929,
                "lower": 8.929
              },
              "label": {
                "text": 79.1,
                "sup": null,
                "override": ""
              },
              "nvalue": 47
            },
            {
              "x": "8",
              "y": 76.5,
              "extreme": {
                "upper": 9.673,
                "lower": 9.673
              },
              "label": {
                "text": 76.5,
                "sup": null,
                "override": ""
              },
              "nvalue": 47
            },
            {
              "x": "9",
              "y": 71.98,
              "extreme": {
                "upper": 10.768,
                "lower": 10.768
              },
              "label": {
                "text": 71.98,
                "sup": null,
                "override": ""
              },
              "nvalue": 48
            },
            {
              "x": "10",
              "y": 68.37,
              "extreme": {
                "upper": 10.507,
                "lower": 10.507
              },
              "label": {
                "text": 68.37,
                "sup": null,
                "override": ""
              },
              "nvalue": 49
            },
            {
              "x": "11",
              "y": 66.13,
              "extreme": {
                "upper": 10.286,
                "lower": 10.286
              },
              "label": {
                "text": 66.13,
                "sup": null,
                "override": ""
              },
              "nvalue": 49
            },
            {
              "x": "12",
              "y": 69.61,
              "extreme": {
                "upper": 10.813,
                "lower": 10.813
              },
              "label": {
                "text": 69.61,
                "sup": null,
                "override": ""
              },
              "nvalue": 49
            }
          ]
        }
      ]
    },
    {
      "name": "sol-150-screening",
      "color": "#73cac3",
      "sets": [
        {
          "name": "sol-150-screening",
          "color": "#73cac3",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 150 mg at screening, mean",
          "tooltipLabel": "Solriamfetol 150 mg at screening",
          "points": [
            {
              "x": "1",
              "y": 71.49,
              "extreme": {
                "upper": 10.175,
                "lower": 10.175
              },
              "label": {
                "text": 71.49,
                "sup": null,
                "override": ""
              },
              "nvalue": 108
            },
            {
              "x": "2",
              "y": 75.94,
              "extreme": {
                "upper": 10.345,
                "lower": 10.345
              },
              "label": {
                "text": 75.94,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "3",
              "y": 78.76,
              "extreme": {
                "upper": 10.221,
                "lower": 10.221
              },
              "label": {
                "text": 78.76,
                "sup": null,
                "override": ""
              },
              "nvalue": 111
            },
            {
              "x": "4",
              "y": 77.51,
              "extreme": {
                "upper": 9.842,
                "lower": 9.842
              },
              "label": {
                "text": 77.51,
                "sup": null,
                "override": ""
              },
              "nvalue": 112
            },
            {
              "x": "5",
              "y": 76.46,
              "extreme": {
                "upper": 10.363,
                "lower": 10.363
              },
              "label": {
                "text": 76.46,
                "sup": null,
                "override": ""
              },
              "nvalue": 112
            },
            {
              "x": "6",
              "y": 76.38,
              "extreme": {
                "upper": 11.458,
                "lower": 11.458
              },
              "label": {
                "text": 76.38,
                "sup": null,
                "override": ""
              },
              "nvalue": 114
            },
            {
              "x": "7",
              "y": 78.18,
              "extreme": {
                "upper": 12.194,
                "lower": 12.194
              },
              "label": {
                "text": 78.18,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "8",
              "y": 75.93,
              "extreme": {
                "upper": 10.421,
                "lower": 10.421
              },
              "label": {
                "text": 75.93,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "9",
              "y": 72.14,
              "extreme": {
                "upper": 10.054,
                "lower": 10.054
              },
              "label": {
                "text": 72.14,
                "sup": null,
                "override": ""
              },
              "nvalue": 114
            },
            {
              "x": "10",
              "y": 67.98,
              "extreme": {
                "upper": 9.585,
                "lower": 9.585
              },
              "label": {
                "text": 67.98,
                "sup": null,
                "override": ""
              },
              "nvalue": 113
            },
            {
              "x": "11",
              "y": 66.45,
              "extreme": {
                "upper": 9.571,
                "lower": 9.571
              },
              "label": {
                "text": 66.45,
                "sup": null,
                "override": ""
              },
              "nvalue": 111
            },
            {
              "x": "12",
              "y": 68.02,
              "extreme": {
                "upper": 10.134,
                "lower": 10.134
              },
              "label": {
                "text": 68.02,
                "sup": null,
                "override": ""
              },
              "nvalue": 111
            }
          ]
        }
      ]
    },
    {
      "name": "sol-150-w8",
      "color": "#73cac3",
      "sets": [
        {
          "name": "sol-150-w8",
          "color": "#73cac3",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Solriamfetol 150 mg at week 8, mean",
          "tooltipLabel": "Solriamfetol 150 mg at week 8",
          "points": [
            {
              "x": "1",
              "y": 72.2,
              "extreme": {
                "upper": 10.496,
                "lower": 10.496
              },
              "label": {
                "text": 72.2,
                "sup": null,
                "override": ""
              },
              "nvalue": 97
            },
            {
              "x": "2",
              "y": 78.05,
              "extreme": {
                "upper": 9.778,
                "lower": 9.778
              },
              "label": {
                "text": 78.05,
                "sup": null,
                "override": ""
              },
              "nvalue": 97
            },
            {
              "x": "3",
              "y": 78.85,
              "extreme": {
                "upper": 9.531,
                "lower": 9.531
              },
              "label": {
                "text": 78.85,
                "sup": null,
                "override": ""
              },
              "nvalue": 97
            },
            {
              "x": "4",
              "y": 78.78,
              "extreme": {
                "upper": 9.739,
                "lower": 9.739
              },
              "label": {
                "text": 78.78,
                "sup": null,
                "override": ""
              },
              "nvalue": 98
            },
            {
              "x": "5",
              "y": 77.48,
              "extreme": {
                "upper": 9.922,
                "lower": 9.922
              },
              "label": {
                "text": 77.48,
                "sup": null,
                "override": ""
              },
              "nvalue": 98
            },
            {
              "x": "6",
              "y": 78.09,
              "extreme": {
                "upper": 10.069,
                "lower": 10.069
              },
              "label": {
                "text": 78.09,
                "sup": null,
                "override": ""
              },
              "nvalue": 97
            },
            {
              "x": "7",
              "y": 77.3,
              "extreme": {
                "upper": 9.73,
                "lower": 9.73
              },
              "label": {
                "text": 77.3,
                "sup": null,
                "override": ""
              },
              "nvalue": 100
            },
            {
              "x": "8",
              "y": 75.18,
              "extreme": {
                "upper": 9.406,
                "lower": 9.406
              },
              "label": {
                "text": 75.18,
                "sup": null,
                "override": ""
              },
              "nvalue": 102
            },
            {
              "x": "9",
              "y": 71.69,
              "extreme": {
                "upper": 9.114,
                "lower": 9.114
              },
              "label": {
                "text": 71.69,
                "sup": null,
                "override": ""
              },
              "nvalue": 100
            },
            {
              "x": "10",
              "y": 68.16,
              "extreme": {
                "upper": 8.93,
                "lower": 8.93
              },
              "label": {
                "text": 68.16,
                "sup": null,
                "override": ""
              },
              "nvalue": 99
            },
            {
              "x": "11",
              "y": 67.26,
              "extreme": {
                "upper": 9.896,
                "lower": 9.896
              },
              "label": {
                "text": 67.26,
                "sup": null,
                "override": ""
              },
              "nvalue": 99
            },
            {
              "x": "12",
              "y": 68.71,
              "extreme": {
                "upper": 10.85,
                "lower": 10.85
              },
              "label": {
                "text": 68.71,
                "sup": null,
                "override": ""
              },
              "nvalue": 99
            }
          ]
        }
      ]
    },
    {
      "name": "sol-300-screening",
      "color": "#be5b92",
      "sets": [
        {
          "name": "sol-300-screening",
          "color": "#be5b92",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 300 mg at screening, mean",
          "tooltipLabel": "Solriamfetol 300 mg at screening",
          "points": [
            {
              "x": "1",
              "y": 72.26,
              "extreme": {
                "upper": 9.081,
                "lower": 9.081
              },
              "label": {
                "text": 72.26,
                "sup": null,
                "override": ""
              },
              "nvalue": 107
            },
            {
              "x": "2",
              "y": 77.33,
              "extreme": {
                "upper": 9.463,
                "lower": 9.463
              },
              "label": {
                "text": 77.33,
                "sup": null,
                "override": ""
              },
              "nvalue": 107
            },
            {
              "x": "3",
              "y": 79.98,
              "extreme": {
                "upper": 9.906,
                "lower": 9.906
              },
              "label": {
                "text": 79.98,
                "sup": null,
                "override": ""
              },
              "nvalue": 106
            },
            {
              "x": "4",
              "y": 77.9,
              "extreme": {
                "upper": 10.33,
                "lower": 10.33
              },
              "label": {
                "text": 77.9,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "5",
              "y": 77.48,
              "extreme": {
                "upper": 10.084,
                "lower": 10.084
              },
              "label": {
                "text": 77.48,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "6",
              "y": 76.9,
              "extreme": {
                "upper": 9.044,
                "lower": 9.044
              },
              "label": {
                "text": 76.9,
                "sup": null,
                "override": ""
              },
              "nvalue": 111
            },
            {
              "x": "7",
              "y": 78.5,
              "extreme": {
                "upper": 9.332,
                "lower": 9.332
              },
              "label": {
                "text": 78.5,
                "sup": null,
                "override": ""
              },
              "nvalue": 108
            },
            {
              "x": "8",
              "y": 77.72,
              "extreme": {
                "upper": 9.199,
                "lower": 9.199
              },
              "label": {
                "text": 77.72,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "9",
              "y": 74.06,
              "extreme": {
                "upper": 10.422,
                "lower": 10.422
              },
              "label": {
                "text": 74.06,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            },
            {
              "x": "10",
              "y": 67.78,
              "extreme": {
                "upper": 9.08,
                "lower": 9.08
              },
              "label": {
                "text": 67.78,
                "sup": null,
                "override": ""
              },
              "nvalue": 108
            },
            {
              "x": "11",
              "y": 66.93,
              "extreme": {
                "upper": 8.984,
                "lower": 8.984
              },
              "label": {
                "text": 66.93,
                "sup": null,
                "override": ""
              },
              "nvalue": 107
            },
            {
              "x": "12",
              "y": 67.7,
              "extreme": {
                "upper": 9.014,
                "lower": 9.014
              },
              "label": {
                "text": 67.7,
                "sup": null,
                "override": ""
              },
              "nvalue": 109
            }
          ]
        }
      ]
    },
    {
      "name": "sol-300-w8",
      "color": "#be5b92",
      "sets": [
        {
          "name": "sol-300-w8",
          "color": "#be5b92",
          "line": "dashed",
          "shape": "hollow",
          "nValueLabel": "Solriamfetol 300 mg at week 8, mean",
          "tooltipLabel": "Solriamfetol 300 mg at week 8",
          "points": [
            {
              "x": "1",
              "y": 76.38,
              "extreme": {
                "upper": 15.655,
                "lower": 15.655
              },
              "label": {
                "text": 76.38,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "2",
              "y": 80.26,
              "extreme": {
                "upper": 13.197,
                "lower": 13.197
              },
              "label": {
                "text": 80.26,
                "sup": null,
                "override": ""
              },
              "nvalue": 84
            },
            {
              "x": "3",
              "y": 81.81,
              "extreme": {
                "upper": 11.317,
                "lower": 11.317
              },
              "label": {
                "text": 81.81,
                "sup": null,
                "override": ""
              },
              "nvalue": 84
            },
            {
              "x": "4",
              "y": 81.57,
              "extreme": {
                "upper": 12.54,
                "lower": 12.54
              },
              "label": {
                "text": 81.57,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "5",
              "y": 81.35,
              "extreme": {
                "upper": 13.926,
                "lower": 13.926
              },
              "label": {
                "text": 81.35,
                "sup": null,
                "override": ""
              },
              "nvalue": 88
            },
            {
              "x": "6",
              "y": 79.97,
              "extreme": {
                "upper": 10.749,
                "lower": 10.749
              },
              "label": {
                "text": 79.97,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "7",
              "y": 81.17,
              "extreme": {
                "upper": 11.056,
                "lower": 11.056
              },
              "label": {
                "text": 81.17,
                "sup": null,
                "override": ""
              },
              "nvalue": 86
            },
            {
              "x": "8",
              "y": 78.61,
              "extreme": {
                "upper": 10.362,
                "lower": 10.362
              },
              "label": {
                "text": 78.61,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "9",
              "y": 74.87,
              "extreme": {
                "upper": 15.051,
                "lower": 15.051
              },
              "label": {
                "text": 74.87,
                "sup": null,
                "override": ""
              },
              "nvalue": 87
            },
            {
              "x": "10",
              "y": 69.41,
              "extreme": {
                "upper": 13.614,
                "lower": 13.614
              },
              "label": {
                "text": 69.41,
                "sup": null,
                "override": ""
              },
              "nvalue": 88
            },
            {
              "x": "11",
              "y": 69.49,
              "extreme": {
                "upper": 13.935,
                "lower": 13.935
              },
              "label": {
                "text": 69.49,
                "sup": null,
                "override": ""
              },
              "nvalue": 85
            },
            {
              "x": "12",
              "y": 70.36,
              "extreme": {
                "upper": 12.286,
                "lower": 12.286
              },
              "label": {
                "text": 70.36,
                "sup": null,
                "override": ""
              },
              "nvalue": 83
            }
          ]
        }
      ]
    }
  ]
};